// extracted by mini-css-extract-plugin
export default {"p":"about-property_p__swa2Z"};